// services/api/productService.js
import axios from "axios";
import { API_URL } from "@/config/env";

export const getProducts = async () => {
  try {
    console.log("[ProductService] Fetching all products");
    const response = await axios.get(`${API_URL}/api/food/list`);
    console.log("[ProductService] Raw API Response:", response);

    if (!response.data.data) {
      console.warn("[ProductService] No data in response");
      return [];
    }

    const products = Array.isArray(response.data.data)
      ? response.data.data
      : [];
    console.log("[ProductService] Processed products:", products);
    return products;
  } catch (error) {
    console.error("[ProductService] Error fetching products:", error);
    throw error;
  }
};
